var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('div',{staticClass:"col-md-12 overflow-auto"},[_c('b-table',{ref:"table",staticClass:"vuetable",attrs:{"stacked":(_vm.$mobile==1),"items":_vm.items},scopedSlots:_vm._u([{key:"cell(ID)",fn:function(data){return [_c('router-link',{attrs:{"to":{
            name: 'Direct',
            params: {
              id: data.item.ID,
            },
          }}},[_vm._v(" "+_vm._s(data.item.ID)+" ")])]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }